var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-sub-title",class:{'is-white': _vm.isWhite}},[_c('div',[_vm._v(_vm._s(_vm.text))]),_vm._t("default"),_c('div',{staticClass:"box-sub-title-line"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }